import { mutate } from 'swr'
import { useCurrentUser } from './use-current-user'
import { MIN_COIN_FOR_CODING } from '@/lib/constant'
import { pushModal } from '@/components/modals'
import { useWorkspaces } from './subscriptions/use-workspaces'
import { useProjectStore } from './use-project-store'

export function useUserCoin() {
  const { data } = useCurrentUser()
  const { workspaces } = useWorkspaces()
  const project = useProjectStore((state) => state.project)

  const refresh = async () => {
    await mutate('/api/me')
  }

  /**
   * Check if user has sufficient credits to use AI features
   * Logic:
   * 1. For workspace projects: check workspace coins first, then fallback to user coins
   * 2. For personal projects: check user coins
   * 3. Only show modal if BOTH workspace and user coins are insufficient
   */
  const checkOutOfCredit = () => {
    const userCoins = data?.coin ?? 0

    // If this is a workspace project, check workspace coins first
    if (project?.workspace_id) {
      const workspace = workspaces.find(
        (ws) => ws._id.toString() === project.workspace_id,
      )
      const workspaceCoins = workspace?.available_coins ?? 0

      // If workspace has sufficient coins, no need to check user coins
      if (workspaceCoins >= MIN_COIN_FOR_CODING) {
        return false
      }

      // Workspace coins insufficient - fallback to user coins
      if (userCoins >= MIN_COIN_FOR_CODING) {
        return false
      }

      // Both insufficient - show modal
      pushModal('PricingModal', {
        type: 'out_of_credit',
        workspaceId: project.workspace_id,
      })
      return true
    }

    // Personal project: only check user coins
    if (userCoins < MIN_COIN_FOR_CODING) {
      pushModal('PricingModal', {
        type: 'out_of_credit',
      })
      return true
    }
    return false
  }

  return {
    coin: data?.coin,
    refresh,
    checkOutOfCredit,
  }
}
